import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './components/App'

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Failed to find the root element.')

const root = ReactDOM.createRoot(rootEl)

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
)
